module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ext-button', _vm._b({
    attrs: {
      "size": _vm.size,
      "factor": _vm.factor,
      "block": _vm.block
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click', $event)
      }
    }
  }, 'ext-button', _vm.$props, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f4fcaf5","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/button/Default.vue
// module id = 35da081f0539e772d1e7
// module chunks = 0